<template>
  <div class="host">
    <div class="controlArea">
      <div v-show="gotOrder" class="overallAmount">
        RM <span>{{ productsTotalToString(products) }}</span>
        <span v-show="extraShippingFee" class="extraShippingFee"
          >满 {{ this.minFreeShippingAmount }} 免邮</span
        >
      </div>
      <div v-show="!gotOrder" class="logo-center">
        <img class="logo" src="./assets/logo.png" />
        <img class="logo" src="./assets/logo-chicken-alt.png" />
      </div>
      <div v-show="gotOrder" class="buttonArea">
        <button @click="reset()" type="button">重来</button>
        <a :href="whatsAppLink" class="button light" target="_blank">下单</a>
      </div>
    </div>
    <div class="products">
      <div
        v-for="product in products"
        v-bind:key="product.name"
        v-bind:class="{ active: product.soldOut || product.isOpen }"
        class="product"
      >
        <div class="frameImage">
          <img :src="product.imageSrc" />
          <div class="title">{{ product.name }}</div>
          <div class="price">RM {{ decimalPoint(product.price) }}</div>
          <div
            v-show="!product.soldOut"
            @click="product.isOpen = true"
            class="cover"
          >
            <div class="box">
              <p class="description">
                <b>{{ product.name + "\n" }}</b
                >{{ product.description }}
              </p>
              <div :class="{ open: product.order > 0 }" class="selected">
                <p>
                  已选择 <b>{{ product.order }}</b> {{ product.unit }}
                </p>
                <p class="total">
                  总共 RM <span>{{ productTotal(product) }}</span>
                </p>
              </div>
              <div class="orderButtonArea">
                <button
                  v-show="product.order > 0"
                  @click="product.order = 0"
                  class="small"
                  type="button"
                >
                  取消
                </button>
                <button
                  @click="product.order++"
                  class="primary small"
                  type="button"
                >
                  <span v-show="product.order > 0">再</span>来 1
                  {{ product.unit }}
                </button>
              </div>
            </div>
          </div>
          <div v-show="product.soldOut" class="cover center">
            <div class="box">已售完</div>
          </div>
        </div>
        <div class="learnMoreButtonArea">
          <button
            v-show="product.isOpen"
            @click="product.isOpen = false"
            class="medium"
            type="button"
          >
            关闭
          </button>
          <button
            v-show="!product.isOpen"
            @click="product.isOpen = true"
            class="medium"
            type="button"
          >
            了解更多
          </button>
          <button
            @click="
              product.order++;
              product.isOpen = true;
            "
            class="primary medium"
            type="button"
          >
            <span v-show="product.order > 0">再</span>来 1
            {{ product.unit }}
          </button>
        </div>
      </div>
    </div>
    <div class="note">
      消费满 RM {{ this.minFreeShippingAmount }} 或以上即可免邮哦!
    </div>
    <div class="cta">
      <a :href="whatsAppLink" class="button light" target="_blank"
        >立即<span>{{
          gotOrder ? "下单 (总共 RM " + overallTotal(products) + ")" : "联系"
        }}</span></a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: [],
  data() {
    return {
      products: [
        {
          name: "虾米卷（经济）",
          price: 26,
          imageSrc: "9.jpg",
          order: 0,
          unit: "包",
          description: "-内馅虾米辣（普通辣度）\n-1 包 500 gram",
          isOpen: false,
          soldOut: false,
        },
      ],
      extraShippingFee: true,
      gotOrder: false,
      whatsAppLink:
        "https://api.whatsapp.com/send/?phone=60197728161&text=您好!",
      minFreeShippingAmount: 150,
      shippingAmount: 15,
      shippingLocation: "新山",
    };
  },
  methods: {
    async fetchShipping() {
      try {
        const response = await fetch(
          "https://hongtzechicken.my/api/shippings.php"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log("Shipping Data:", data);
        const dataRow = data.results?.[0];

        // Update data
        this.minFreeShippingAmount = parseFloat(dataRow.minFreeShippingAmount);
        this.shippingAmount = parseFloat(dataRow.shippingAmount);

        // Update WhatsApp link base
        const phone = dataRow.contact || "60197728161"; // fallback if not provided
        this.whatsAppLink = `https://api.whatsapp.com/send/?phone=${phone}&text=您好!`;

      } catch (error) {
        console.error("Error fetching shipping info:", error);
      }
    },
    async fetchProducts() {
      try {
        const response = await fetch(
          "https://hongtzechicken.my/api/products.php"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data.results);

        // Initialize additional properties on each product
        this.products = data.results.map((product) => ({
          ...product,
          price: parseInt(product.price),
          imageSrc: product.images[0],
          soldOut: product.sold === 1,
          isOpen: false,
          order: 0,
        }));
        console.log(this.products[0]);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
    decimalPoint(val) {
      return val.toFixed(2);
    },
    productTotal(product) {
      return (product.price * product.order).toFixed(2);
    },
    productsTotal(products) {
      return products.reduce(
        (total, product) => total + product.price * product.order,
        0
      );
    },
    productsTotalToString(products) {
      return this.productsTotal(products).toFixed(2);
    },
    overallTotal(products) {
      let productTotalAmount = this.productsTotal(products);

      if (this.extraShippingFee) {
        productTotalAmount += this.shippingAmount;
      }
      return productTotalAmount.toFixed(2);
    },
    reset() {
      this.products.forEach((product) => (product.order = 0));
    },
  },
  watch: {
    products: {
      deep: true,
      handler(products) {
        const filteredProducts = products.filter((p) => p.order > 0);
        let orderList = [];
        filteredProducts.forEach((product) => {
          orderList.push(
            `${product.name} x${product.order}${product.unit} =${(
              product.price * product.order
            ).toFixed(2)}`
          );
        });

        this.gotOrder = orderList.length > 0;
        this.extraShippingFee =
          this.productsTotal(products) < this.minFreeShippingAmount;

        const touchAndGoLink = window.encodeURI(
          "https://payment.tngdigital.com.my/sc/bDLn1GpOoe"
        );
        const whatsAppLinkString = this.whatsAppLink.substring(
          0,
          this.whatsAppLink.indexOf("&text=") + 6
        );
        if (filteredProducts.length > 0) {
          if (this.extraShippingFee) {
            orderList.push(
              this.shippingLocation + "邮费(RM " + this.shippingAmount + ")"
            );
          }
          this.whatsAppLink =
            whatsAppLinkString +
            "您好! 我需要购买%0a%0a" +
            orderList.join("%0a") +
            "%0a%0a总共 %2ARM " +
            this.overallTotal(products) +
            "%2A";

          if (this.extraShippingFee) {
            this.whatsAppLink +=
              "%0a消费满 RM" +
              this.minFreeShippingAmount +
              " 或以上即可免邮哦!";
          } else {
            this.whatsAppLink += " (" + this.shippingLocation + "免邮)";
          }
          this.whatsAppLink +=
            "%0a%0a_付款方式%3A_%0a%2ATouch n Go%2A%0a" +
            touchAndGoLink +
            "%0a%0a%2ABank Transfer%2A%0aPublic Bank%0a3240663229%0aHONG TZE CHICKEN %26 DUCK SUPPLIER SDN BHD";
        } else {
          this.whatsAppLink = whatsAppLinkString + "您好!";
        }
      },
    },
  },
  mounted() {
    this.fetchProducts();
    this.fetchShipping();
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  max-width: 600px;
  margin: auto;
  background: white;
  background-image: linear-gradient(
      90deg,
      rgba(200, 0, 0, 0.5) 50%,
      transparent 0
    ),
    linear-gradient(rgba(200, 0, 0, 0.5) 50%, transparent 0);
  background-size: 30px 30px;
  font-family: "Noto Sans SC", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
$color1: #dde1e4;
$color2: #694d47;
$color3: #e58c50;
$color4: #f5c984;
$color5: #f0ddaa;
$color6: #f4eed0;
$color7: #ffc639;
$paddingLeft: 4px;

.host {
  background-color: $color1;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.75);
  color: $color2;
}

button,
.button {
  background-color: $color5;
  border: 1px solid $color4;
  color: black;
  border-radius: 4px;
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
  padding: 4px 8px;
  text-decoration: none;
  text-align: center;

  &.primary {
    background-color: $color2;
    border: 1px solid $color2;
    color: $color1;
  }

  &.light {
    background-color: #ffc639;
    border: 1px solid #ffc639;
    color: black;
  }

  &.medium {
    font-size: 14px;
    padding: 4px 8px;
  }

  &.small {
    font-size: 13px;
    padding: 2px 8px;
  }

  &:active {
    position: relative;
    top: 1px;
  }
}

.controlArea {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 3px 14px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
  // background-color: $color6;
  background-color: $color7;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.75);
  .overallAmount {
    font-size: 22px;
    font-weight: 700;
  }
  .extraShippingFee {
    margin-left: 4px;
    font-size: 16px;
    font-weight: normal;
  }
  .buttonArea {
    a {
      margin-left: 6px;
    }
  }
  .logo {
    margin: auto;
    height: 40px;
  }
}
.products {
  padding: 16px $paddingLeft;
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  gap: 24px 8px;
  @media (max-width: 359px) {
    padding: 16px 8px;
    grid-template-columns: repeat(1, 2fr);
  }
}
.product {
  &.active {
    .frameImage {
      img,
      .price,
      .title {
        filter: blur(1px);
      }
      .cover {
        opacity: 1;
        .box {
          transform: translateY(0);
        }
      }
    }
  }
  .frameImage {
    border-radius: 4px;
    overflow: hidden;
    padding-bottom: calc(4 / 3 * 100%);
    position: relative;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
    img {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #dbdbdb;
    }
    .title {
      position: absolute;
      width: 100%;
      bottom: 16%;
      color: white;
      text-align: center;
      font-size: 20px;
      text-shadow: 2px 2px 5px rgb(0 0 0), 2px 2px 5px rgb(0 0 0),
        2px 2px 5px rgb(0 0 0);
    }
    .price {
      position: absolute;
      width: 100%;
      bottom: 5%;
      color: white;
      text-align: center;
      font-size: 20px;
      text-shadow: 2px 2px 5px rgb(0 0 0), 2px 2px 5px rgb(0 0 0),
        2px 2px 5px rgb(0 0 0);
    }
    .cover {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: 0.3s;
      &.center {
        text-align: center;
      }
      .box {
        background-color: $color1;
        color: $color2;
        width: 90%;
        font-size: 18px;
        padding: 4px 0;
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
        transform: translateY(300%);
        transition: 0.3s ease-in;
        .description {
          width: 100%;
          padding: 4px 6px;
          font-size: 13px;
          line-height: 1.2;
          white-space: pre-line;
        }
        .selected {
          border-top-width: 0;
          border-top-color: $color2;
          border-top-style: dashed;
          max-height: 0;
          transition: 0.3s ease-out;
          overflow: hidden;
          text-align: center;
          font-size: 15px;
          &.open {
            border-top-width: 1px;
            max-height: 300px;
            transition: 0.3s ease-in;
          }
          .total {
            margin-bottom: 6px;
          }
        }
        .orderButtonArea {
          text-align: center;
          border-top: 1px dashed $color2;
          button:last-child {
            margin-left: 6px;
          }
        }
      }
    }
  }
  .soldOut {
    padding: 4px;
    position: absolute;
    left: 5%;
    top: calc(50% - 5px);
    width: 90%;
    background-color: $color1;
    color: $color2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    border-radius: 4px;
  }
  .learnMoreButtonArea {
    margin-top: 8px;
    text-align: center;
    button:last-child {
      margin-left: 10px;
    }
  }
}
.note {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.cta {
  position: sticky;
  bottom: 0;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.73);
  .button {
    width: 100%;
    border-radius: 0;
    padding: 8px 16px;
  }
}
</style>
